
import Vue from 'vue'
import App from './App.vue'
import { router, authHeader } from './_helpers'
import './prprenotachefcookie.js'
import axios from 'axios'
// import FullCalendar from 'vue-full-calendar'
import './registerServiceWorker'

import 'fullcalendar/dist/fullcalendar.css'
import 'bootstrap'
import './scss/app.scss'

import $ from 'jquery'

import VeeValidateIT from 'vee-validate/dist/locale/it'
import VeeValidate, { Validator } from 'vee-validate'

import moment from 'moment'

import VueSweetalert2 from 'vue-sweetalert2'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

import { store } from './_store'
import VueMatomo from 'vue-matomo'

import anime from 'animejs'
import AppMarker from '@/components/AppMarker.vue'
import AppCategory from '@/components/AppCategory.vue'

Vue.use(VueSweetalert2)

moment.locale('it')

global.$ = $

window.base_url = 'https://agendaeventi.comune.parma.it/api'
window.base_image_url = 'https://agendaeventi.comune.parma.it/internalimage/'
window.credential = {
  'clientid': 'e+YGzMd39o1NUcsF3jKHHBUlBDPGcfNew6+4t2v86P0LYQAeRR1fe56Jv9GDEVKWzWs=',
  'secret': '8UY)EUlmZT'
}

// Vue.use(VueMatomo, {
//   router: router,
//   host: 'https://analytics.comune.parma.it',
//   siteId: 60,
//   trackerUrl: 'https://analytics.comune.parma.it/matomo.php',
//   enableLinkTracking: true,
//   requireConsent: false,
//   trackInitialView: true,
//   disableCookies: true,
//   enableHeartBeatTimer: true,
//   debug: false,
// })

// Vue.use(VueMatomo, {
//   router: router,
//   host: 'https://ingestion.webanalytics.italia.it',
//   siteId: 'jLp6w22qWQ',
//   trackerUrl: 'https://ingestion.webanalytics.italia.it/matomo.php',
//   enableLinkTracking: true,
//   requireConsent: false,
//   trackInitialView: true,
//   disableCookies: true,
//   enableHeartBeatTimer: true,
//   debug: false,
// })

var primaryTracker = 'https://analytics.comune.parma.it'
var primaryWebsiteId = '60'
var secondaryTracker = 'https://ingestion.webanalytics.italia.it/matomo.php'
var secondaryWebsiteId = 'jLp6w22qWQ'
window.anime = anime
switch (process.env.NODE_ENV) {
  case 'production':
    axios.get('../settings').then(result => {
      Object.assign(window, result.data)

      axios.defaults.baseURL = window.base_url

      nextProcedure()
    }).catch()
    break
  default:
    axios.defaults.baseURL = window.base_url

    nextProcedure()
    break
}
$(function () {
  $(document).on('show.bs.collapse', '#navbar-main', function () {
    let viewHeight = $(window).outerHeight() + 100

    let before = anime({
      targets: '.navbar__before path',
      d: [
        {
          value: 'M-1,1 L-1,' + viewHeight + ' L210,' + viewHeight + ' L421,' + viewHeight + ' L421,-1 L-1,-1 Z',
          easing: [0.645, 0.045, 0.355, 1.000]
        }
      ],
      duration: 800,
      loop: false
    })

    let after = anime({
      targets: '.navbar__after .dark path',
      d: [
        {
          value: 'M0,0 L0,' + viewHeight + ' L421,' + viewHeight + ' L421,0 L0,0 Z'
        },
        {
          value: 'M0,' + viewHeight + ' L0,' + viewHeight + ' L421,' + viewHeight + ' L421,' + viewHeight + ' L0,' + viewHeight + ' Z'
        }
      ],
      easing: [0.645, 0.045, 0.355, 1.000],
      delay: 0,
      duration: 1400,
      loop: false
    })

    let after2 = anime({
      targets: '.navbar__after .secondary path',
      d: [
        {
          value: 'M0,0 L0,' + viewHeight + ' L421,' + viewHeight + ' L421,0 L0,0 Z'
        },
        {
          value: 'M0,' + viewHeight + ' L0,' + viewHeight + ' L421,' + viewHeight + ' L421,' + viewHeight + ' L0,' + viewHeight + ' Z'
        }
      ],
      easing: [0.645, 0.045, 0.355, 1.000],
      delay: 200,
      duration: 1000,
      loop: false
    })

    let after3 = anime({
      targets: '.navbar__after .primary path',
      d: [
        {
          value: 'M0,0 L0,' + viewHeight + ' L421,' + viewHeight + ' L421,0 L0,0 Z'
        },
        {
          value: 'M0,' + viewHeight + ' L0,' + viewHeight + ' L421,' + viewHeight + ' L421,' + viewHeight + ' L0,' + viewHeight + ' Z'
        }
      ],
      easing: [0.645, 0.045, 0.355, 1.000],
      delay: 400,
      duration: 600,
      loop: false
    })

    let navbar = anime({
      targets: '.navbar',
      zIndex: 1050
    })

    let nav = anime({
      targets: '.navbar-nav--main',
      opacity: 1,
      delay: 450,
      easing: 'linear',
      duration: 1
    })
  })

  $(document).on('hide.bs.collapse', '#navbar-main', function () {
    let nav = anime({
      targets: '.navbar-nav--main',
      opacity: 0,
      delay: 900,
      easing: 'linear',
      duration: 1
    })

    let navbar = anime({
      targets: '.navbar',
      zIndex: 1020,
      delay: 1200
    })

    let before = anime({
      targets: '.navbar__before path',
      d: [
        {
          value: 'M-1,1 L-1,1 L210,14 L421,1 L421,-1 L-1,-1 Z',
          easing: [0.645, 0.045, 0.355, 1.000]
        }
      ],
      duration: 800,
      delay: 600,
      loop: false
    })

    let viewHeight = $(window).outerHeight() + 100

    let after = anime({
      targets: '.navbar__after .dark path',
      d: [
        {
          value: 'M0,0 L0,' + viewHeight + ' L421,' + viewHeight + ' L421,0 L0,0 Z'
        },
        {
          value: 'M0,0 L0,0 L421,0 L421,0 L0,0 Z'
        }
      ],
      easing: [0.645, 0.045, 0.355, 1.000],
      delay: 0,
      duration: 1400,
      loop: false
    })

    let after2 = anime({
      targets: '.navbar__after .secondary path',
      d: [
        {
          value: 'M0,0 L0,' + viewHeight + ' L421,' + viewHeight + ' L421,0 L0,0 Z'
        },
        {
          value: 'M0,0 L0,0 L421,0 L421,0 L0,0 Z'
        }
      ],
      easing: [0.645, 0.045, 0.355, 1.000],
      delay: 200,
      duration: 1000,
      loop: false
    })

    let after3 = anime({
      targets: '.navbar__after .primary path',
      d: [
        {
          value: 'M0,0 L0,' + viewHeight + ' L421,' + viewHeight + ' L421,0 L0,0 Z'
        },
        {
          value: 'M0,0 L0,0 L421,0 L421,0 L0,0 Z'
        }
      ],
      easing: [0.645, 0.045, 0.355, 1.000],
      delay: 400,
      duration: 600,
      loop: false
    })
  })

  $(document).on('shown.bs.collapse', '#navbar-search', function () {
    let nav = anime({
      targets: '.navbar-nav--search',
      translateY: ['-101%', 0],
      easing: [0.645, 0.045, 0.355, 1.000],
      duration: 300
    })
  })

  $(document).on('hide.bs.collapse', '#navbar-search', function () {
    let nav = anime({
      targets: '.navbar-nav--search',
      translateY: [0, '-101%'],
      easing: [0.645, 0.045, 0.355, 1.000],
      duration: 300
    })
  })
})

Vue.component('appMarker', AppMarker)
Vue.component('appCategory', AppCategory)

function nextProcedure () {
  Vue.filter('formatDate', function (value) {
    if (value) {
      return moment(String(value)).format('dddd DD MMMM YYYY HH:mm')
    }
  })

  Vue.filter('formatEventDate', function (value) {
    if (value) {
      var day = moment(String(value)).format('DD MMMM YYYY')
      var min = moment(String(value)).format('HH:mm')
      return day + ' alle ' + min
    }
  })

  Vue.filter('formatSessionDate', function (value) {
    if (value) {
      var day = moment(String(value)).format('ddd DD MMM')
      var min = moment(String(value)).format('HH:mm')
      return day + ' alle ' + min
    }
  })
  //  Vue.use(FullCalendar)
  Vue.config.productionTip = false

  Vue.use(AppMarker)

  Vue.use(VeeValidate, {
    events: 'change'
  })
  Validator.localize('it', VeeValidateIT)

  store.dispatch('authentication/token', window.credential).then(response => {
    axios.defaults.headers.common['Authorization'] = authHeader()
    Vue.use(VueMatomo, {
      host: primaryTracker,
      siteId: primaryWebsiteId,
      router: router,
      enableLinkTracking: true,
      requireConsent: false,
      trackInitialView: true,
      disableCookies: false,
      requireCookieConsent: false,
      enableHeartBeatTimer: true,
      heartBeatTimerInterval: 5,

      // Changes the default .js and .php endpoint's filename
      // Default: 'matomo'
      // trackerFileName: 'piwik',

      // Overrides the tracker endpoint entirely
      // Default: undefined
      trackerUrl: undefined,

      // Overrides the tracker script path entirely
      // Default: undefined
      trackerScriptUrl: undefined,

      // Whether or not to log debug information
      // Default: false
      debug: false,

      // User ID
      // Default: undefined
      // userId: 'some-user-id',

      preInitActions: [
        ['addTracker', secondaryTracker, secondaryWebsiteId]
      ]
    })

    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })
}
